module.exports = __webpack_public_path__ + "static/media/targeted.b4ce8dd7.svg";